import Typography from '@app/components/atoms/Typography';
import styled from 'styled-components';

export const ImageContainer = styled.div`
  margin-right: 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 6px;
  }
  position: relative;
`;

export const LightboxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  overflow: hidden;
  margin-top: 2rem;
`;

export const StyledTypography = styled(Typography)`
  && {
    position: absolute;
    color: white;
    font-weight: bold;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
`;

export const StyledIconBox = styled.div`
  position: absolute;
  bottom: 0;
  right: 10px;
  svg:hover {
    fill: ${({ theme }) => theme.primary.main};
    cursor: pointer;
  }
`;
